import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 7px 13px;
  background: #f6f6f6;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;
